
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CreditCard, Download } from 'lucide-react';
import { Bill } from './types';

interface BillsTableProps {
  bills: Bill[];
  activeTab: string;
  onPayNow: (bill: Bill) => void;
}

const BillsTable = ({ bills, activeTab, onPayNow }: BillsTableProps) => {
  
  const getBadgeColor = (status: string) => {
    switch (status) {
      case 'Paid':
        return <Badge className="bg-green-500">Paid</Badge>;
      case 'Unpaid':
        return <Badge className="bg-amber-500">Unpaid</Badge>;
      case 'Overdue':
        return <Badge className="bg-red-500">Overdue</Badge>;
      default:
        return <Badge>{status}</Badge>;
    }
  };

  const filteredBills = 
    activeTab === 'current' 
      ? bills.filter(bill => bill.status === 'Unpaid')
      : activeTab === 'history'
        ? bills.filter(bill => bill.status === 'Paid')
        : bills;

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader className="bg-muted/50">
          <TableRow>
            <TableHead className="font-medium">Bill ID</TableHead>
            <TableHead className="font-medium">Month</TableHead>
            <TableHead className="font-medium">Amount</TableHead>
            {(activeTab === 'current') && <TableHead className="font-medium">Due Date</TableHead>}
            {(activeTab === 'history' || activeTab === 'all') && <TableHead className="font-medium">Consumption</TableHead>}
            <TableHead className="font-medium">Status</TableHead>
            <TableHead className="font-medium text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredBills.map((bill) => (
            <TableRow key={bill.id} className="hover:bg-muted/50">
              <TableCell className="font-medium">{bill.id}</TableCell>
              <TableCell>{bill.month}</TableCell>
              <TableCell>${bill.amount.toFixed(2)}</TableCell>
              {(activeTab === 'current') && (
                <TableCell>{new Date(bill.dueDate).toLocaleDateString()}</TableCell>
              )}
              {(activeTab === 'history' || activeTab === 'all') && (
                <TableCell>{bill.consumption} kWh</TableCell>
              )}
              <TableCell>{getBadgeColor(bill.status)}</TableCell>
              <TableCell className="text-right">
                {bill.status === 'Unpaid' ? (
                  <Button onClick={() => onPayNow(bill)} className="bg-energy-blue hover:bg-blue-700 text-white">
                    <CreditCard className="mr-2 h-4 w-4" />
                    Pay Now
                  </Button>
                ) : (
                  <Button variant="outline" size="sm">
                    <Download className="mr-2 h-4 w-4" />
                    Download
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default BillsTable;
